/**
 * Tooltips for the select family, in one place (styles.scss "SELECT CONVENTION"): a panel is exactly as wide as its trigger,
 * so a long option wraps in the panel and a long selected value is ellipsized in a narrow (compact) trigger; either way the full
 * text is the element's `title`. One delegated, passive `mouseover` on the document, so no select needs its own template.
 * The title is set lazily (on first hover) and only on the trigger label when it is actually clipped.
 */
const OPTION = '.p-select-option, .p-multiselect-option';
const LABEL = '.p-select-label, .p-multiselect-label';

export function installSelectTitles(doc: Document): () => void {
  const onOver = (event: Event): void => {
    const target = event.target as Element | null;
    if (!target?.closest) return;
    const option = target.closest<HTMLElement>(OPTION);
    if (option) {
      const text = (option.textContent ?? '').trim();
      if (text && option.title !== text) option.title = text;
      return;
    }
    const label = target.closest<HTMLElement>(LABEL);
    if (label) {
      const text = (label.textContent ?? '').trim();
      const clipped = label.scrollWidth > label.clientWidth;
      if (clipped && text) label.title = text;
      else label.removeAttribute('title');
    }
  };
  doc.addEventListener('mouseover', onOver, { passive: true });
  return () => doc.removeEventListener('mouseover', onOver);
}
